import React, { useState } from "react";
import { useSeriesShowContext } from "../SeriesShowApp";
import { toastError } from "../../../shared/toastHelper";
import SeriesHeader from "./SeriesHeader";
import SeriesTabs from "./SeriesTabs";
import KpiCards from "./KpiCards";
import SeriesFinanceCards from "./SeriesFinanceCards";
import NextEventCard from "./NextEventCard";
import ScheduleTable from "./ScheduleTable";
import CollectionDetailsCard from "./CollectionDetailsCard";
import ShowActivitiesCard from "./ShowActivitiesCard";
import PassesTab from "./PassesTab";
import SeriesPassesTab from "./SeriesPassesTab";
import "../styles/seriesShowStyles.css";

const SeriesShow = () => {
  const { series, refreshSeries } = useSeriesShowContext();
  // "Sell passes for this series" lands on the new collection's Passes tab.
  const [activeTab, setActiveTab] = useState(() => (
    new URLSearchParams(window.location.search).get("tab") === "passes" && series.series_passes_enabled
      && (series.grouping || series.member_of_collections !== undefined) ? "passes" : "events"
  ));

  const handleSelectTab = (key) => {
    setActiveTab(key);
    if (key === "events" || key === "passes") {
      refreshSeries().catch(() => toastError("Could not refresh the series. Please reload the page."));
    }
  };

  const eventsCount = series.summary_stats && series.summary_stats.events_in_series
    ? series.summary_stats.events_in_series.total
    : undefined;

  const tabs = [
    { key: "events", label: "Events", count: eventsCount },
    { key: "details", label: "Details" },
  ];

  // Passes & packs live only on collections, and only when the team's package has
  // the series_passes feature (dark by default). A recurring series gets a
  // read-only tab listing the passes of the collections that include it.
  const passCount = series.grouping
    ? (series.series_pass_products || []).length
    : (series.member_of_collections || []).reduce((total, collection) => total + (collection.series_pass_products || []).length, 0);
  // The series' read-only tab is part of collections, so it stays dark with them:
  // member_of_collections is only sent while collections are on.
  const passesTab = series.grouping || series.member_of_collections !== undefined;
  if (series.series_passes_enabled && passesTab) {
    tabs.push({
      key: "passes",
      label: "Passes & Packs",
      count: passCount,
    });
  }

  return (
    <div className="series-show">
      <SeriesHeader />
      <SeriesTabs tabs={tabs} activeTab={activeTab} onSelect={handleSelectTab} />
      {activeTab === "events" && (
        <>
          <KpiCards />
          <SeriesFinanceCards />
          {series.next_event && <NextEventCard />}
          <ScheduleTable />
        </>
      )}
      {activeTab === "details" && (
        <div className="row">
          <div className="col-12 col-lg-5">
            <CollectionDetailsCard />
          </div>
          <div className="col-12 col-lg-7">
            <ShowActivitiesCard />
          </div>
        </div>
      )}
      {activeTab === "passes" && (series.grouping ? <PassesTab /> : <SeriesPassesTab />)}
    </div>
  );
};

export default SeriesShow;
